export const OPEN_DIALOG = "DIALOGS::OPEN"
export const CLOSE_DIALOG = "DIALOGS::CLOSE"
export const SET_DIALOG_DATA = "DIALOGS::DATA::SET"
